import React from 'react'
import CreateAutomationRule from 'src/app/CreateAutomationRule/CreateAutomationRule'
import { SidenavContentType } from 'src/navigation/appLocations'
import { AppRoute } from 'src/navigation/appRoutes'
import { createAutomationRuleRouteProps } from 'src/navigation/routeProps'

import { AppLocation } from '../appLocations'

const CreateAutomationRuleAppRoute: AppRoute = {
  id: AppLocation.CreateAutomationRule,
  routeProps: createAutomationRuleRouteProps,
  component: <CreateAutomationRule />,
  subRoutes: [],
  meta: { contentType: SidenavContentType.Settings },
}

export default CreateAutomationRuleAppRoute
